
interface FlowStepProps {
  step: number;
  wrapperPosition: string;
}

export const FlowStep: React.FC<FlowStepProps> = ({ step, wrapperPosition }) => {

  return (
    <div className={`${wrapperPosition === 'absolute' ? 'fixed-flow-step' : ''}`}>
      <div className='steps-wrapper'>
        <div className={`step-element${step === 1 ? '-active' : '-disabled'}`}>
          <div className="step-number">1</div>
          <div className="step-title">Selección banco</div>
        </div>
        <div className={`step-element${step === 2 ? '-active' : '-disabled'}`}>
          <div className="step-number">2</div>
          <div className="step-title">Revisión de datos</div>
        </div>
        <div className={`step-element${step === 3 ? '-active' : '-disabled'}`}>
          <div className="step-number">3</div>
          <div className="step-title">Confirmación</div>
        </div>
      </div>
    </div>
  )
}
